export default "__VITE_ASSET__Q57HA5xd__"